document.addEventListener('DOMContentLoaded', function() {
  const navButtons = document.querySelectorAll('.nav-button');
  const contentSections = document.querySelectorAll('.content-section');
  const contentDisplayWrapper = document.querySelector('.content-display-wrapper');

  const sectionColors = {
    'content-quienes-somos': {
      borderColor: '#f7931e', // Naranja
      titleColor: '#f7931e',
      buttonColor: '#f7931e'
    },
    'content-mision': {
      borderColor: '#00aaff', // Azul
      titleColor: '#00aaff',
      buttonColor: '#00aaff'
    },
    'content-vision': {
      borderColor: '#00e676', // Verde
      titleColor: '#00e676',
      buttonColor: '#00e676'
    },
    'content-politica-calidad': {
      borderColor: '#00aaff',
      titleColor: '#00aaff',
      buttonColor: '#00aaff'
    }
  };

  let isAnimating = false; // Bandera para evitar clics múltiples durante la animación

  // Función principal para actualizar la UI y manejar la animación
  async function updateUI(targetId, clickedButton = null) {
    if (isAnimating) return; // Si ya hay una animación en curso, ignora el clic
    isAnimating = true;

    const currentActiveSection = document.querySelector('.content-section.active');
    const targetSection = document.getElementById(targetId);

    if (!targetSection || targetSection === currentActiveSection) {
      isAnimating = false; // No hay cambio o ya es la sección activa
      return;
    }

    // 1. Desactivar sección actual y botones
    // Si hay una sección activa, la preparamos para "salir"
    if (currentActiveSection) {
      currentActiveSection.classList.add('leaving'); // Agrega la clase de salida
      currentActiveSection.classList.remove('active'); // Quita 'active' para que 'leaving' tome control
      await new Promise(resolve => setTimeout(resolve, 400)); // Espera a que termine la animación de salida
      currentActiveSection.classList.remove('leaving'); // Limpia la clase después de salir
      currentActiveSection.style.cssText = ''; // Limpia estilos inline que puedan quedar
    }

    navButtons.forEach(button => {
      button.classList.remove('active');
      const defaultButtonColor = sectionColors[button.dataset.target] ? sectionColors[button.dataset.target].buttonColor : '#f7931e';
      button.style.backgroundColor = defaultButtonColor;
    });

    // 2. Obtener la posición del botón clicado (si existe) o un punto central por defecto
    let initialX, initialY, initialWidth, initialHeight;
    if (clickedButton) {
      const buttonRect = clickedButton.getBoundingClientRect();
      const wrapperRect = contentDisplayWrapper.getBoundingClientRect();

      // Calcular la posición del botón relativa al wrapper de contenido
      initialX = buttonRect.left - wrapperRect.left;
      initialY = buttonRect.top - wrapperRect.top;
      initialWidth = buttonRect.width;
      initialHeight = buttonRect.height;
    } else {
      // Si no hay botón (ej. al cargar la página), inicia desde el centro del wrapper
      initialX = contentDisplayWrapper.offsetWidth / 2;
      initialY = contentDisplayWrapper.offsetHeight / 2;
      initialWidth = 0; // Empieza pequeño
      initialHeight = 0;
    }

    // 3. Preparar la nueva sección para la animación de entrada
    targetSection.classList.add('active-animating');
    targetSection.style.top = `${initialY}px`;
    targetSection.style.left = `${initialX}px`;
    targetSection.style.width = `${initialWidth}px`;
    targetSection.style.height = `${initialHeight}px`;
    targetSection.style.opacity = '0'; // Asegura que empiece invisible


    // Asegurar que los h3 de otras secciones no tengan colores remanentes de otras activaciones
    contentSections.forEach(section => {
      if (section.id !== targetId) {
        const h3 = section.querySelector('.content-header h3');
        if (h3) h3.style.color = '#000'; // O un color neutro
      }
    });

    // Pequeño retardo para asegurar que el navegador registre el estado inicial antes de animar
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // 4. Iniciar la animación al estado final
        targetSection.classList.add('active-final'); // Dispara la animación CSS a su estado final
        targetSection.style.opacity = '1'; // Ahora visible

        // 5. Aplicar colores dinámicos al wrapper y al título
        const colors = sectionColors[targetId];
        if (colors) {
          contentDisplayWrapper.style.borderColor = colors.borderColor;
          const activeH3 = targetSection.querySelector('.content-header h3');
          if (activeH3) {
            activeH3.style.color = colors.titleColor;
          }
        }

        // 6. Activar el botón correspondiente
        const activeButton = document.querySelector(`.nav-button[data-target="${targetId}"]`);
        if (activeButton) {
          activeButton.classList.add('active');
          if (colors) {
            activeButton.style.backgroundColor = colors.buttonColor;
          }
        }
      });
    });

    // Esperar a que termine la animación
    targetSection.addEventListener('transitionend', function handler(event) {
      if (event.propertyName === 'transform' || event.propertyName === 'opacity') {
        targetSection.classList.remove('active-animating', 'active-final');
        targetSection.classList.add('active'); // Ahora es la sección activa normal
        targetSection.style.cssText = ''; // Limpia estilos inline de posicionamiento
        targetSection.removeEventListener('transitionend', handler);
        isAnimating = false; // La animación ha terminado, permitir nuevos clics
      }
    });
  }

  // Manejador de eventos para los botones de navegación
  navButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetId = this.dataset.target;
      updateUI(targetId, this); // Pasa el botón clicado
    });
  });

  // Inicializar con la sección activa por defecto (Política de Calidad)
  const initialActiveSection = document.querySelector('.content-section.active');
  if (initialActiveSection) {
    // Para la carga inicial, simula el "origen" desde el botón activo o desde el centro
    const initialButton = document.querySelector(`.nav-button[data-target="${initialActiveSection.id}"]`);
    updateUI(initialActiveSection.id, initialButton);
  } else {
    if (contentSections.length > 0) {
      // Si no hay ninguna activa en HTML, activa la primera sin un botón de origen específico
      updateUI(contentSections[0].id);
    }
  }
});